import { t } from "@lingui/macro";
import * as React from "react";
import { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const PrintIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Print`} {...props}>
    <G id="Selected" clip-path="url(#clip0_1082_11032)">
      <Path
        id="Rectangle 1375"
        d="M13 12H15V4H1V12H3"
        stroke="currentColor"
        strokeWidth="1.25"
        fill="none"
      />
      <Path
        id="Rectangle 1376"
        d="M12 4V1H4V4"
        stroke="currentColor"
        strokeWidth="1.25"
        fill="none"
      />
      <Path
        id="Rectangle 1378"
        d="M3.5 8V15H12.5V8"
        stroke="currentColor"
        strokeWidth="1.25"
        fill="none"
      />
      <Path
        id="Rectangle 1377"
        d="M2 8H14"
        stroke="currentColor"
        strokeWidth="1.25"
        fill="none"
      />
      <Path
        id="Rectangle 1379"
        d="M5 10.5H11"
        stroke="currentColor"
        strokeWidth="1.25"
        fill="none"
      />
      <Path
        id="Rectangle 1380"
        d="M5 12.5H11"
        stroke="currentColor"
        strokeWidth="1.25"
        fill="none"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_1082_11032">
        <Rect width="16" height="16" fill="white" />
      </ClipPath>
    </Defs>
  </Icon>
);
